<template>
  <div class="section">
    <div class="container " style="max-width:600px !important">
       <h1 class="title is-2 ">Contact Us</h1>
        <div>Have a question, suggestion, feature request, or just want to say hi? Send a message using the form below.</div><br><br>

        <form action="https://formspree.io/xgenlgyy" method="POST">
            <b-field>
                <b-input  placeholder="your name" name="name" type="text" size="is-medium"></b-input>
            </b-field>
            <b-field>
                <b-input required placeholder="your email" name="_replyto" type="text" size="is-medium"></b-input>
            </b-field>
            <b-field>
                <b-input required placeholder="your message" name="message" type="textarea" size="is-medium"></b-input>
            </b-field>
            <b-button native-type="submit" type="is-primary">Send</b-button>
            
            </form>

    </div>

  </div>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
    }
  },
  metaInfo() {
        return {
            title: 'Contact Bike Sleep Bike',
            description: "Contact Bike Sleep Bike"
            
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>





// WEBPACK FOOTER //
// src/components/Contact.vue